export default {
    entityKey: 'pipelines',
    basePath: '/pipelines',
    titles: {
        singular: 'Pipeline',
        plural: 'Pipelines'
    }
}
